import type { DeepString } from "@/lib/i18n";

/**
 * OAuthButtons — polskie tłumaczenia (przyciski Logowanie z Facebook/Google).
 *
 * Komponent jest shared (używany w CUserAccounts katalogu i WUserAccount oknie),
 * dlatego trzyma własne tłumaczenia — konsumenci NIE muszą przekazywać `t` prop.
 */
export const pl = {
  /** Separator między formą login a przyciskami social. */
  dividerOr: "lub",
  /** Etykieta przycisku Facebook (gdy SDK gotowy). */
  facebookButton: "Zaloguj z Facebook",
  /** Etykieta na czas trwania zapytania (busy state). */
  signingIn: "Logowanie…",
  /** User zamknął okienko FB bez logowania. */
  facebookCancelled: "Logowanie z Facebook zostało anulowane.",
  /** Backend zwrócił błąd dla FB flow. */
  facebookFailed: "Nie udało się zalogować przez Facebook.",
  /** Backend zwrócił błąd dla Google flow. */
  googleFailed: "Nie udało się zalogować przez Google.",
} as const;

export type OAuthButtonsTranslations = DeepString<typeof pl>;
